
export const masterFrameCodes:any = [
  {
    "KKCode": "190LBHCR",
    "KKDescription": "LH Butt Hinges Concealed Exit",
    "KKType": 1
  },
  {
    "KKCode": "190LBHCR1X",
    "KKDescription": "LH Butt Hinges Concealed Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190LBHCR2X",
    "KKDescription": "LH Butt Hinges Concealed Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190LBHMS",
    "KKDescription": "LH Butt Hinges MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190LBHMS1X",
    "KKDescription": "LH Butt Hinges MS Locking 1 Xrail",
    "KKType": 1
  },
  {
    "KKCode": "190LBHMS2X",
    "KKDescription": "LH Butt Hinges MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190LBHPNLN",
    "KKDescription": "LH Butt Hinges Paneline",
    "KKType": 1
  },
  {
    "KKCode": "190LBHRM",
    "KKDescription": "LH Butt Hinges Rim Exit",
    "KKType": 1
  },
  {
    "KKCode": "190LBHRM1X",
    "KKDescription": "LH Butt Hinges Rim exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190LBHRM2X",
    "KKDescription": "LH Butt Hinges Rim Exit 2 Xrails",
    "KKType": 1
  },
  {
    "KKCode": "190LCEMS",
    "KKDescription": "LH Center Hung End Load MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190LCEMS1X",
    "KKDescription": "LH Center Hung End Load MS Locking 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190LCEMS2X",
    "KKDescription": "LH Center Hung End Load MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190LCGHCR",
    "KKDescription": "LH Continuous Hinge Concealed Exit",
    "KKType": 1
  },
  {
    "KKCode": "190LCGHCR1X",
    "KKDescription": "LH Continuous Hinge Concealed Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190LCGHCR2X",
    "KKDescription": "LH Continuous Hinge Concealed Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190LCGHMS",
    "KKDescription": "LH Continuous Hinge MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190LCGHMS1X",
    "KKDescription": "LH Continuous Hinge MS Locking 1 Xrail",
    "KKType": 1
  },
  {
    "KKCode": "190LCGHMS2X",
    "KKDescription": "LH Continuous Hinge MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190LCGHPNLN",
    "KKDescription": "LH Continuous Hinge Paneline",
    "KKType": 1
  },
  {
    "KKCode": "190LCGHRM",
    "KKDescription": "LH Continuous Hinge Rim Exit",
    "KKType": 1
  },
  {
    "KKCode": "190LCGHRM1X",
    "KKDescription": "LH Continuous Hinge Rim exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190LCGHRM2X",
    "KKDescription": "LH Continuous Hinge Rim Exit 2 Xrails",
    "KKType": 1
  },
  {
    "KKCode": "190LCSMS",
    "KKDescription": "LH Center Hung Side Load MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190LCSMS1X",
    "KKDescription": "LH Center Hung Side Load MS Locking 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190LCSMS2X",
    "KKDescription": "LH Center Hung Side Load MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190LOPCR",
    "KKDescription": "LH Offset Pivot Concealed Exit",
    "KKType": 1
  },
  {
    "KKCode": "190LOPCR1X",
    "KKDescription": "LH Offset Pivot Concealed Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190LOPCR2X",
    "KKDescription": "LH Offset Pivot Concealed Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190LOPMS",
    "KKDescription": "LH Offset Pivot MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190LOPMS1X",
    "KKDescription": "LH Offset Pivot MS Locking 1 Xrail",
    "KKType": 1
  },
  {
    "KKCode": "190LOPMS2X",
    "KKDescription": "LH Offset Pivot MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190LOPPNLN",
    "KKDescription": "LH Offset Pivot Paneline",
    "KKType": 1
  },
  {
    "KKCode": "190LOPRM",
    "KKDescription": "LH Offset Pivot Rim Exit",
    "KKType": 1
  },
  {
    "KKCode": "190LOPRM1X",
    "KKDescription": "LH Offset Pivot Rim exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190LOPRM2X",
    "KKDescription": "LH Offset Pivot Rim Exit 2 Xrails",
    "KKType": 1
  },
  {
    "KKCode": "190PBHCR",
    "KKDescription": "Pair Butt Hinges Concealed Exit",
    "KKType": 1
  },
  {
    "KKCode": "190PBHCR1X",
    "KKDescription": "Pair Butt Hinges Concealed Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190PBHCR2X",
    "KKDescription": "Pair Butt Hinges Concealed Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190PBHMS",
    "KKDescription": "Pair Butt Hinges MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190PBHMS1X",
    "KKDescription": "Pair Butt Hinges MS Locking 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190PBHMS2X",
    "KKDescription": "Pair Butt Hinges MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190PBHPNLN",
    "KKDescription": "Pair Butt Hinges Paneline",
    "KKType": 1
  },
  {
    "KKCode": "190PBHRM",
    "KKDescription": "Pair Butt Hinges Rim Exit",
    "KKType": 1
  },
  {
    "KKCode": "190PBHRM1X",
    "KKDescription": "Pair Butt Hinges Rim Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190PBHRM2X",
    "KKDescription": "Pair Butt Hinges Rim Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190PCEMS",
    "KKDescription": "Pair Center Hung End Load MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190PCEMS1X",
    "KKDescription": "Pair Center Hung End Load MS Locking 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190PCEMS2X",
    "KKDescription": "Pair Center Hung End Load MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190PCGHCR",
    "KKDescription": "Pair Continuous Hinge Concealed Exit",
    "KKType": 1
  },
  {
    "KKCode": "190PCGHCR1X",
    "KKDescription": "Pair Continuous Hinge Concealed Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190PCGHCR2X",
    "KKDescription": "Pair Continuous Hinge Concealed Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190PCGHMS",
    "KKDescription": "Pair Continuous Hinge MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190PCGHMS1X",
    "KKDescription": "Pair Continuous Hinge MS Locking 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190PCGHMS2X",
    "KKDescription": "Pair Continuous Hinge MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190PCGHPNLN",
    "KKDescription": "Pair Continuous Hinge Paneline",
    "KKType": 1
  },
  {
    "KKCode": "190PCGHRM",
    "KKDescription": "Pair Continuous Hinge Rim Exit",
    "KKType": 1
  },
  {
    "KKCode": "190PCGHRM1X",
    "KKDescription": "Pair Continuous Hinge Rim Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190PCGHRM2X",
    "KKDescription": "Pair Continuous Hinge Rim Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190PCSMS",
    "KKDescription": "Pair Center Hung Side Load MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190PCSMS1X",
    "KKDescription": "Pair Center Hung Side Load MS Locking 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190PCSMS2X",
    "KKDescription": "Pair Center Hung Side Load MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190POPCR",
    "KKDescription": "Pair Offset Pivots Concealed Exit",
    "KKType": 1
  },
  {
    "KKCode": "190POPCR1X",
    "KKDescription": "Pair Offset Pivots Concealed Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190POPCR2X",
    "KKDescription": "Pair Offset Pivots Concealed Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190POPMS",
    "KKDescription": "Pair Offset Pivots MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190POPMS1X",
    "KKDescription": "Pair Offset Pivots MS Locking 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190POPMS2X",
    "KKDescription": "Pair Offset Pivots MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190POPPNLN",
    "KKDescription": "Pair Offset Pivots Paneline",
    "KKType": 1
  },
  {
    "KKCode": "190POPRM",
    "KKDescription": "Pair Offset Pivots Rim Exit",
    "KKType": 1
  },
  {
    "KKCode": "190POPRM1X",
    "KKDescription": "Pair Offset Pivots Rim Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190POPRM2X",
    "KKDescription": "Pair Offset Pivots Rim Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190RBHCR",
    "KKDescription": "RH Butt Hinges Concealed Exit",
    "KKType": 1
  },
  {
    "KKCode": "190RBHCR1X",
    "KKDescription": "RH Butt Hinges Concealed Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190RBHCR2X",
    "KKDescription": "RH Butt Hinges Concealed Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190RBHMS",
    "KKDescription": "RH Butt Hinges MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190RBHMS1X",
    "KKDescription": "RH Butt Hinges MS Locking 1 Xrail",
    "KKType": 1
  },
  {
    "KKCode": "190RBHMS2X",
    "KKDescription": "RH Butt Hinges MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190RBHPNLN",
    "KKDescription": "RH Butt Hinges Paneline",
    "KKType": 1
  },
  {
    "KKCode": "190RBHRM",
    "KKDescription": "RH Butt Hinges Rim Exit",
    "KKType": 1
  },
  {
    "KKCode": "190RBHRM1X",
    "KKDescription": "RH Butt Hinges Rim exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190RBHRM2X",
    "KKDescription": "RH Butt Hinges Rim Exit 2 Xrails",
    "KKType": 1
  },
  {
    "KKCode": "190RCEMS",
    "KKDescription": "RH Center Hung End Load MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190RCEMS1X",
    "KKDescription": "RH Center Hung End Load MS Locking 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190RCEMS2X",
    "KKDescription": "RH Center Hung End Load MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190RCGHCR",
    "KKDescription": "RH Continuous Hinge Concealed Exit",
    "KKType": 1
  },
  {
    "KKCode": "190RCGHCR1X",
    "KKDescription": "RH Continuous Hinge Concealed Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190RCGHCR2X",
    "KKDescription": "RH Continuous Hinge Concealed Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190RCGHMS",
    "KKDescription": "RH Continuous Hinge MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190RCGHMS1X",
    "KKDescription": "RH Continuous Hinge MS Locking 1 Xrail",
    "KKType": 1
  },
  {
    "KKCode": "190RCGHMS2X",
    "KKDescription": "RH Continuous Hinge MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190RCGHPNLN",
    "KKDescription": "RH Continuous Hinge Paneline",
    "KKType": 1
  },
  {
    "KKCode": "190RCGHRM",
    "KKDescription": "RH Continuous Hinge Rim Exit",
    "KKType": 1
  },
  {
    "KKCode": "190RCGHRM1X",
    "KKDescription": "RH Continuous Hinge Rim exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190RCGHRM2X",
    "KKDescription": "RH Continuous Hinge Rim Exit 2 Xrails",
    "KKType": 1
  },
  {
    "KKCode": "190RCSMS",
    "KKDescription": "RH Center Hung Side Load MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190RCSMS1X",
    "KKDescription": "RH Center Hung Side Load MS Locking 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190RCSMS2X",
    "KKDescription": "RH Center Hung Side Load MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190ROPCR",
    "KKDescription": "RH Offset Pivot Concealed Exit",
    "KKType": 1
  },
  {
    "KKCode": "190ROPCR1X",
    "KKDescription": "RH Offset Pivot Concealed Exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190ROPCR2X",
    "KKDescription": "RH Offset Pivot Concealed Exit 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190ROPMS",
    "KKDescription": "RH Offset Pivot MS Locking",
    "KKType": 1
  },
  {
    "KKCode": "190ROPMS1X",
    "KKDescription": "RH Offset Pivot MS Locking 1 Xrail",
    "KKType": 1
  },
  {
    "KKCode": "190ROPMS2X",
    "KKDescription": "RH Offset Pivot MS Locking 2 XRails",
    "KKType": 1
  },
  {
    "KKCode": "190ROPPNLN",
    "KKDescription": "RH Offset Pivot Paneline",
    "KKType": 1
  },
  {
    "KKCode": "190ROPRM",
    "KKDescription": "RH Offset Pivot Rim Exit",
    "KKType": 1
  },
  {
    "KKCode": "190ROPRM1X",
    "KKDescription": "RH Offset Pivot Rim exit 1 XRail",
    "KKType": 1
  },
  {
    "KKCode": "190ROPRM2X",
    "KKDescription": "RH Offset Pivot Rim Exit 2 Xrails",
    "KKType": 1
  },
  {
    "KKCode": "450LBHCR36",
    "KKDescription": "3'-0\" LH Butt Hinge CR Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LBHCR36TR",
    "KKDescription": "3'-0\" LH Butt Hinge CR Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LBHMS36",
    "KKDescription": "3'-0\" LH Butt Hinge MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LBHMS36TR",
    "KKDescription": "3'-0\" LH Butt Hinge MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LBHMS42",
    "KKDescription": "3'-6\" LH Butt Hinge MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LBHMS42TR",
    "KKDescription": "3'-6\" LH Butt Hinge MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LBHPNL36",
    "KKDescription": "3'-0\" LH Butt Hinge Paneline Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LBHPNL36TR",
    "KKDescription": "3'-0\" LH Butt Hinge Paneline Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LBHRM36",
    "KKDescription": "3'-0\" LH Butt Hinge Rim Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LBHRM36TR",
    "KKDescription": "3'-0\" LH Butt Hinge RM Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LCGHCR36",
    "KKDescription": "3'-0\" LH Cont Hinge CR Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LCGHCR36TR",
    "KKDescription": "3'-0\" LH Cont Hinge CR Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LCGHMS36",
    "KKDescription": "3'-0\" LH Cont Hinge MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LCGHMS36TR",
    "KKDescription": "3'-0\" LH Cont Hinge MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LCGHMS42",
    "KKDescription": "3'-6\" LH Cont Hinge MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LCGHMS42TR",
    "KKDescription": "3'-6\" LH Cont Hinge MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LCGHPNL36",
    "KKDescription": "3'-0\" LH Cont Hinge Paneline Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LCGHPNL36TR",
    "KKDescription": "3'-0\" LH Cont Hinge Paneline Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LCGHRM36",
    "KKDescription": "3'-0\" LH Cont Hinge Rim Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LCGHRM36TR",
    "KKDescription": "3'-0\" LH Cont Hinge RM Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LOPCR36",
    "KKDescription": "3'-0\" LH Offset Pivot CR Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LOPCR36TR",
    "KKDescription": "3'-0\" LH Offset Pivot CR Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LOPMS36",
    "KKDescription": "3'-0\" LH Offset Pivot MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LOPMS36TR",
    "KKDescription": "3'-0\" LH Offset Pivot MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LOPMS42",
    "KKDescription": "3'-6\" LH Offset Pivot MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LOPMS42TR",
    "KKDescription": "3'-6\" LH Offset Pivot MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LOPPNL36",
    "KKDescription": "3'-0\" LH Offset Pivot Paneline Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LOPPNL36TR",
    "KKDescription": "3'-0\" LH Offset Pivot Paneline Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450LOPRM36",
    "KKDescription": "3'-0\" LH Offset Pivot Rim Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450LOPRM36TR",
    "KKDescription": "3'-0\" LH Offset Pivot RM Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450PBHCR72",
    "KKDescription": "6'-0\" PR Butt Hinge CR Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450PBHCR72TR",
    "KKDescription": "6'-0\" PR Butt Hinge CR Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450PBHMS72",
    "KKDescription": "6'-0\" PR Butt Hinge MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450PBHMS72TR",
    "KKDescription": "6'-0\" PR Butt Hinge MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450PBHPNL72",
    "KKDescription": "6'-0\" PR Butt Hinge Paneline Frame",
    "KKType": 2
  },
  {
    "KKCode": "450PBHPNL72TR",
    "KKDescription": "6'-0\" PR Butt Hinge Paneline Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450PBHRM72",
    "KKDescription": "6'-0\" PR Butt Hinge Rim Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450PBHRM72TR",
    "KKDescription": "6'-0\" PR Butt Hinge RM Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450PCEMS72",
    "KKDescription": "6'-0\" PR Center Pivot MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450PCEMS72TR",
    "KKDescription": "6'-0\" PR Center Pivot MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450PCGHCR72",
    "KKDescription": "6'-0\" PR Cont Hinge CR Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450PCGHCR72TR",
    "KKDescription": "6'-0\" PR Cont Hinge CR Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450PCGHMS72",
    "KKDescription": "6'-0\" PR Cont Hinge MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450PCGHMS72TR",
    "KKDescription": "6'-0\" PR Cont Hinge MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450PCGHPNL72",
    "KKDescription": "6'-0\" PR Cont Hinge Paneline Frame",
    "KKType": 2
  },
  {
    "KKCode": "450PCGHPNL72TR",
    "KKDescription": "6'-0\" PR Cont Hinge Paneline Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450PCGHRM72",
    "KKDescription": "6'-0\" PR Cont Hinge Rim Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450PCGHRM72TR",
    "KKDescription": "6'-0\" PR Cont Hinge RM Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450POPCR72",
    "KKDescription": "6'-0\" PR Offset Pivot CR Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450POPCR72TR",
    "KKDescription": "6'-0\" PR Offset Pivot CR Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450POPMS72",
    "KKDescription": "6'-0\" PR Offset Pivot MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450POPMS72TR",
    "KKDescription": "6'-0\" PR Offset Pivot MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450POPPNL72",
    "KKDescription": "6'-0\" PR Offset Pivot Paneline Frame",
    "KKType": 2
  },
  {
    "KKCode": "450POPPNL72TR",
    "KKDescription": "6'-0\" PR Offset Pivot Paneline Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450POPRM72",
    "KKDescription": "6'-0\" PR Offset Pivot Rim Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450POPRM72TR",
    "KKDescription": "6'-0\" PR Offset Pivot RM Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450RBHCR36",
    "KKDescription": "3'-0\" RH Butt Hinge CR Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450RBHCR36TR",
    "KKDescription": "3'-0\" RH Butt Hinge CR Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450RBHMS36",
    "KKDescription": "3'-0\" RH Butt Hinge MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450RBHMS36TR",
    "KKDescription": "3'-0\" RH Butt Hinge MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450RBHMS42",
    "KKDescription": "3'-6\" RH Butt Hinge MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450RBHMS42TR",
    "KKDescription": "3'-6\" RH Butt Hinge MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450RBHPNL36",
    "KKDescription": "3'-0\" RH Butt Hinge Paneline Frame",
    "KKType": 2
  },
  {
    "KKCode": "450RBHPNL36TR",
    "KKDescription": "3'-0\" RH Butt Hinge Paneline Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450RBHRM36",
    "KKDescription": "3'-0\" RH Butt Hinge Rim Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450RBHRM36TR",
    "KKDescription": "3'-0\" RH Butt Hinge RM Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450RCGHCR36",
    "KKDescription": "3'-0\" RH Cont Hinge CR Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450RCGHCR36TR",
    "KKDescription": "3'-0\" RH Cont Hinge CR Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450RCGHMS36",
    "KKDescription": "3'-0\" RH Cont Hinge MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450RCGHMS36TR",
    "KKDescription": "3'-0\" RH Cont Hinge MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450RCGHMS42",
    "KKDescription": "3'-6\" RH Cont Hinge MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450RCGHMS42TR",
    "KKDescription": "3'-6\" RH Cont Hinge MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450RCGHPNL36",
    "KKDescription": "3'-0\" RH Cont Hinge Paneline Frame",
    "KKType": 2
  },
  {
    "KKCode": "450RCGHPNL36TR",
    "KKDescription": "3'-0\" RH Cont Hinge Paneline Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450RCGHRM36",
    "KKDescription": "3'-0\" RH Cont Hinge Rim Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450RCGHRM36TR",
    "KKDescription": "3'-0\" RH Cont Hinge RM Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450ROPCR36",
    "KKDescription": "3'-0\" RH Offset Pivot CR Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450ROPCR36TR",
    "KKDescription": "3'-0\" RH Offset Pivot CR Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450ROPMS36",
    "KKDescription": "3'-0\" RH Offset Pivot MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450ROPMS36TR",
    "KKDescription": "3'-0\" RH Offset Pivot MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450ROPMS42",
    "KKDescription": "3'-6\" RH Offset Pivot MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450ROPMS42TR",
    "KKDescription": "3'-6\" RH Offset Pivot MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450ROPPNL36",
    "KKDescription": "3'-0\" RH Offset Pivot Paneline Frame",
    "KKType": 2
  },
  {
    "KKCode": "450ROPPNL36TR",
    "KKDescription": "3'-0\" RH Offset Pivot Paneline Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450ROPRM36",
    "KKDescription": "3'-0\" RH Offset Pivot Rim Panic Frame",
    "KKType": 2
  },
  {
    "KKCode": "450ROPRM36TR",
    "KKDescription": "3'-0\" RH Offset Pivot RM Panic Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450SCEMS36",
    "KKDescription": "3'-0\" SGL Center Pivot MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450SCEMS36TR",
    "KKDescription": "3'-0\" SGL Center Pivot MS Lock Frame w/Transom",
    "KKType": 2
  },
  {
    "KKCode": "450SCEMS42",
    "KKDescription": "3'-6\" SGL Center Pivot MS Lock Frame",
    "KKType": 2
  },
  {
    "KKCode": "450SCEMS42TR",
    "KKDescription": "3'-6\" SGL Center Pivot MS Lock Frame w/Transom",
    "KKType": 2
  }
]

export const kkSetup: any = []

export const KK450_Create: any = {
};
export const KK190_Create: any = {}
export const CreateConfiguration: any = {

}

export const std_1dr_do = {};
export const createDummy: any = {}
